import React from 'react'
import banner from "../../../images/padu/world.webp"
import { LuCircleCheckBig, LuCircleX } from 'react-icons/lu'

export default function Reality() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full overflow-hidden text-center'>
            <img src={banner} alt='banner' loading='lazy' className='mx-auto object-cover w-[180px] md:w-auto' />
            <div className='mt-[14px] md:mt-[25px]'>
                <h3 className='text-[#101828] text-[24px] md:text-[54px] font-semibold'>The New Reality</h3>
                <p className='mt-[5px] md:mt-[10px] text-[#7D7F81] font-normal text-[14px] md:text-[25px]'>Information is not the problem. Identity, mindset & clarity are.</p>
            </div>
            <div className='md:w-11/12 xl:w-10/12 mx-auto mt-[20px] md:mt-[54px] grid md:grid-cols-2 gap-[20px] md:gap-[50px]'>
                <div className='border border-[#B9F8CF] bg-gradient-to-r from-[#F0FDF4] to-[#ECFDF5] rounded-[12px] md:rounded-[28px] p-[15px] md:p-[30px] text-start'>
                    <p className='text-[#0D542B] font-bold text-[20px] md:text-[27px] mt-[12px] md:mt-[25px]'>Today’s Generation Has</p>
                    <div className='mt-[12px] md:mt-[25px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                        <div className='flex gap-[8px] md:gap-[16px] items-center'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0'/>
                            <p>YouTube</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[52px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0'/>
                            <p>Online courses</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[52px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0'/>
                            <p>AI tools</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[52px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0'/>
                            <p>Tutorials</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[52px]'>
                            <LuCircleCheckBig className='text-[14px] md:text-[24px] text-[#00A63E] flex-shrink-0'/>
                            <p>Unlimited content</p>
                        </div>
                    </div>
                </div>
                <div className='border border-[#FFC9C9] bg-[#FEF2F2] rounded-[12px] md:rounded-[28px] p-[15px] md:p-[30px] text-start'>
                    <p className='text-[#82181A] font-bold text-[20px] md:text-[27px] mt-[12px] md:mt-[25px]'>Yet Most Students Feel</p>
                    <div className='mt-[12px] md:mt-[25px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                        <div className='flex gap-[8px] md:gap-[16px] items-center'>
                            <LuCircleX className='text-[14px] md:text-[24px] text-[#FB2C36] flex-shrink-0'/>
                            <p>Confused about their career</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuCircleX className='text-[14px] md:text-[24px] text-[#FB2C36] flex-shrink-0'/>
                            <p>Unsure what path fits them</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuCircleX className='text-[14px] md:text-[24px] text-[#FB2C36] flex-shrink-0'/>
                            <p>Low on confidence</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuCircleX className='text-[14px] md:text-[24px] text-[#FB2C36] flex-shrink-0'/>
                            <p>Fearful about interviews</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuCircleX className='text-[14px] md:text-[24px] text-[#FB2C36] flex-shrink-0'/>
                            <p>Distracted & inconsistent</p>
                        </div>
                        <div className='flex gap-[8px] md:gap-[16px] items-center mt-[18px] md:mt-[36px]'>
                            <LuCircleX className='text-[14px] md:text-[24px] text-[#FB2C36] flex-shrink-0'/>
                            <p>Unsure of real-world expectations</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
